<div class="content-wrapper reports-container">

  <!-- Pestañas -->
  <div class="col-md-12 layout-spacing widget" style="margin-top: 19px; padding: 0 12px 0 12px">
    <div class="w-100 animated-underline-content">
      <ul class="nav nav-tabs mb-0" id="irmTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link" [class.active]="currentTab === 1"
             (click)="switchTab(1)" role="tab" style="cursor:pointer">
            {{ 'record.cio' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="currentTab === 2"
             (click)="switchTab(2)" role="tab" style="cursor:pointer">
            {{ 'directives.tabName' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- TAB 1: Informes IRM -->
  <ng-container *ngIf="currentTab === 1">

  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="margin-top: 10px"
  >
    <a class="widget quick-category">
      <div class="quick-category-head">
        <h5 class="card-title">{{ 'record.filter.title' | translate }}</h5>
        <div class="ml-auto">
          <button
            *ngIf="!areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.contract' | translate }}</span>
            <i class="las la-arrow-up"></i>
          </button>
          <button
            *ngIf="areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.advancedSearch' | translate }}</span>
            <i class="las la-arrow-down"></i>
          </button>
        </div>
      </div>
      <div class="quick-category-content">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.startDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="minDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [maxDate]="maxDate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.endDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="maxDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [minDate]="minDate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row" [ngbCollapse]="areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">{{ 'record.filter.user' | translate }}</h6>
              <div>
                <input
                  [(ngModel)]="user"
                  class="form-control"
                  placeholder="{{ 'record.filter.emailAddress' | translate }}"
                  type="text"
                  id="example-text-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.act' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="actions"
                [closeOnSelect]="false"
                [(ngModel)]="selectedActions"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.department' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="departments"
                [closeOnSelect]="false"
                [(ngModel)]="selectedDeptos"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.label' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="labelsName"
                [closeOnSelect]="false"
                [(ngModel)]="selectedLabels"
                multiple="true"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="btn-filtros">
              <button
                style="padding: 5px 30px; width: 110px"
                type="button"
                class="btn btn-primary"
                (click)="setFilters()"
                [disabled]="isLoading"
              >
                {{ 'record.filter.filter' | translate }}
              </button>
              <button
                style="padding: 5px 0px; width: 110px"
                type="button"
                class="btn btn-outline-primary"
                (click)="cleanFilters()"
                [disabled]="isLoading"
              >
                {{ 'record.filter.cleanFilters' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>

    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 25px;
              width: 165px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
            id="btnGroupVerticalDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="isLoading"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'record.download.download' | translate }}
            <i class="las la-angle-down"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDropdown">
            <button class="dropdown-item" (click)="generateGeneralIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.overviewReport' | translate }}
            </button>
            <button class="dropdown-item" (click)="generateEvoIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.evolutionaryReport' | translate }}
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center gap-1">
          <ng-container *ngIf="!isCountLoading">
            {{ 'record.recordsCount' | translate : { count: reports?.length || '0', total: collectionSize } }}
          </ng-container>
          <ng-container *ngIf="isCountLoading">
            {{ 'record.recordsCountLoading' | translate : { count: reports?.length || '0' } }}
            <span class="spinner-border spinner-border-sm text-secondary" style="width:0.75rem;height:0.75rem;margin-left:4px" role="status" aria-hidden="true"></span>
          </ng-container>
        </div>
      </div>
    </div>

    <table class="table table-striped">
      <thead>
        <tr>
          <th
            style="width: 200px"
            scope="col"
            sortable="date"
            (sort)="onSort($event)"
          >
            {{ 'record.table.date' | translate }}
          </th>
          <th scope="col" sortable="activity" (sort)="onSort($event)">
            {{ 'record.table.act' | translate }}
          </th>
          <th scope="col" sortable="file" (sort)="onSort($event)">
            {{ 'record.table.fileSubject' | translate }}
          </th>
          <th scope="col" sortable="applicationName" (sort)="onSort($event)">
            {{ 'record.table.action' | translate }}
          </th>
          <th scope="col" sortable="actor" (sort)="onSort($event)">
            {{ 'record.table.user' | translate }}
          </th>
          <th scope="col" sortable="area" (sort)="onSort($event)">
            {{ 'record.table.department' | translate }}
          </th>
          <th scope="col" sortable="labelName" (sort)="onSort($event)">
            {{ 'record.table.label' | translate }}
          </th>
          <!-- 
            <th scope="col">

            </th>
            -->
        </tr>
      </thead>
      <tbody *ngIf="isLoading">
        <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
          <td><div class="skeleton skeleton-row"></div></td>
          <td><div class="skeleton skeleton-row"></div></td>
          <td><div class="skeleton skeleton-row"></div></td>
          <td><div class="skeleton skeleton-row"></div></td>
          <td><div class="skeleton skeleton-row"></div></td>
          <td><div class="skeleton skeleton-row"></div></td>
          <td><div class="skeleton skeleton-row"></div></td>
        </tr>
      </tbody>
      <tbody *ngIf="!isLoading">
        <tr *ngFor="let report of reports">
          <td>{{ report.date | tableDate }}</td>
          <td
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ report.activity }}"
          >
            {{ report.activity | cutString }}
          </td>
          <td
            style="cursor: pointer"
            (click)="seeDetails(report.id)"
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ report.file }}"
          >
            {{ report.file | cutString }}
          </td>
          <td>{{ report.applicationName }}</td>
          <td>{{ report.actor }}</td>
          <td>{{ report.area }}</td>
          <td>{{ report.labelName }}</td>
          <!--
            <td>
              <button style="border: none; padding: 0; background: transparent;"><i class="las la-eye font-25"></i></button>
            </td>
          -->
        </tr>
      </tbody>
    </table>

    <div
      *ngIf="reports?.length <= 0 && !isLoading"
      class="d-flex justify-content-center"
    >
      <span>{{ 'noDataAvailable' | translate }}</span>
    </div>
  </div>

  <div
    class="d-flex justify-content-center p-2 paginator-container"
    *ngIf="reports?.length > 0"
  >
    <div class="items-per-page-container">
      <label for="pageSizeSelect" class="mr-2 mb-0">{{
        'record.filter.itemsPerPage' | translate
      }}</label>
      <select
        id="pageSizeSelect"
        class="form-control"
        style="width: auto; display: inline-block"
        [(ngModel)]="pageSize"
        (change)="refreshReports()"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [maxSize]="5"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshReports()"
    >
    </ngb-pagination>
  </div>

  </ng-container>
  <!-- FIN TAB 1 -->

  <!-- TAB 2: Directivas -->
  <ng-container *ngIf="currentTab === 2">
    <div class="col-md-12 layout-spacing widget quick-category" style="margin-top: 10px">
      <a class="widget quick-category">
        <div class="quick-category-head">
          <h5 class="card-title">{{ 'directives.title' | translate }}</h5>
        </div>
        <div class="quick-category-content">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group column">
                <h6 class="card-title">{{ 'directives.userGroup' | translate }}</h6>
                <input
                  [(ngModel)]="dpIdentifier"
                  class="form-control"
                  placeholder="{{ 'directives.searchUserGroup' | translate }}"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group column">
                <h6 class="card-title">{{ 'directives.directive' | translate }}</h6>
                <ng-select
                  class="selectpicker"
                  [items]="dpDirectivasOpciones"
                  [(ngModel)]="dpDirectivas"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  placeholder="{{ 'directives.allDirectives' | translate }}"
                ></ng-select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group column">
                <h6 class="card-title">{{ 'directives.assignmentSource' | translate }}</h6>
                <ng-select
                  class="selectpicker"
                  [items]="dpFuentes"
                  [(ngModel)]="dpFuenteAsignacion"
                  [clearable]="true"
                  placeholder="{{ 'directives.all' | translate }}"
                ></ng-select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group column">
                <h6 class="card-title">{{ 'directives.label' | translate }}</h6>
                <ng-select
                  class="selectpicker"
                  [items]="dpEtiquetasOpciones"
                  [(ngModel)]="dpEtiquetas"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  placeholder="{{ 'directives.allLabels' | translate }}"
                ></ng-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="btn-filtros">
                <button
                  style="padding: 5px 30px; width: 110px"
                  type="button"
                  class="btn btn-primary"
                  (click)="applyDirectivasFilters()"
                  [disabled]="dpIsLoading"
                >
                  {{ 'record.filter.filter' | translate }}
                </button>
                <button
                  style="padding: 5px 0px; width: 110px"
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="cleanDirectivasFilters()"
                  [disabled]="dpIsLoading"
                >
                  {{ 'record.filter.cleanFilters' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </a>

      <!-- KPI cards -->
      <div class="dp-kpi-row" *ngIf="dpStats">
        <div class="dp-kpi-card">
          <span class="dp-kpi-icon"><i class="las la-users"></i></span>
          <div class="dp-kpi-body">
            <span class="dp-kpi-value">{{ dpStats.totalUsuarios }}</span>
            <span class="dp-kpi-label">
              {{ 'directives.kpiTotalUsers' | translate }}
              <i class="las la-info-circle dp-kpi-info"
                 ngbTooltip="{{ 'directives.kpiTotalUsersHint' | translate }}"
                 container="body" placement="top"></i>
            </span>
          </div>
        </div>
        <div class="dp-kpi-card">
          <span class="dp-kpi-icon"><i class="las la-layer-group"></i></span>
          <div class="dp-kpi-body">
            <span class="dp-kpi-value">{{ dpStats.usuariosMultiDirectiva }}</span>
            <span class="dp-kpi-label">
              {{ 'directives.kpiMultiDirective' | translate }}
              <i class="las la-info-circle dp-kpi-info"
                 ngbTooltip="{{ 'directives.kpiTotalUsersHint' | translate }}"
                 container="body" placement="top"></i>
            </span>
          </div>
        </div>
        <div class="dp-kpi-card">
          <span class="dp-kpi-icon"><i class="las la-shield-alt"></i></span>
          <div class="dp-kpi-body">
            <span class="dp-kpi-value">{{ dpDirectivasOpciones.length }}</span>
            <span class="dp-kpi-label">{{ 'directives.kpiActiveDirectives' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="dp-kpi-row" *ngIf="!dpStats && dpStatsLoading">
        <div class="dp-kpi-card dp-kpi-skeleton"><div class="skeleton skeleton-row" style="height:60px"></div></div>
        <div class="dp-kpi-card dp-kpi-skeleton"><div class="skeleton skeleton-row" style="height:60px"></div></div>
        <div class="dp-kpi-card dp-kpi-skeleton"><div class="skeleton skeleton-row" style="height:60px"></div></div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-2 mt-2" style="padding: 0 5px">
        <div class="btn-informes">
          <button
            style="padding: 5px 25px; width: 165px; height: 35px; display: flex; justify-content: center; align-items: center; gap: 6px;"
            id="btnDirectivasDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="dpIsLoading"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'directives.download' | translate }}
            <i class="las la-angle-down"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="btnDirectivasDropdown">
            <button class="dropdown-item" (click)="downloadDirectivas()">
              <i class="icon download-type"></i>
              {{ 'directives.exportExcel' | translate }}
            </button>
          </div>
        </div>
        <div>
          <span *ngIf="!dpIsLoading">{{ 'directives.records' | translate : { shown: dpUsers?.length || 0, total: dpTotal } }}</span>
          <span *ngIf="dpIsLoading" class="text-muted">{{ 'directives.loading' | translate }}</span>
        </div>
      </div>

      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ 'directives.colUserGroup' | translate }}</th>
            <th scope="col">{{ 'directives.colMail' | translate }}</th>
            <th scope="col">{{ 'directives.colDirectives' | translate }}</th>
            <th scope="col" style="width:80px; text-align:center; cursor:pointer; user-select:none" (click)="sortDpBy('numDirectivas')">
              {{ 'directives.colN' | translate }}
              <i class="las" [ngClass]="{
                'la-sort': dpSortBy !== 'numDirectivas',
                'la-sort-up': dpSortBy === 'numDirectivas' && dpSortDir === 'asc',
                'la-sort-down': dpSortBy === 'numDirectivas' && dpSortDir === 'desc'
              }" style="font-size:14px; margin-left:2px"></i>
            </th>
            <th scope="col">{{ 'directives.colSource' | translate }}</th>
            <th scope="col">{{ 'directives.colGroups' | translate }}</th>
            <th scope="col" style="width:100px; text-align:center">{{ 'directives.colLabels' | translate }}</th>
          </tr>
        </thead>
        <tbody *ngIf="dpIsLoading">
          <tr *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
          </tr>
        </tbody>
        <tbody *ngIf="!dpIsLoading">
          <tr *ngFor="let u of dpUsers">
            <td ngbTooltip="{{ u.identifier }}" [openDelay]="300" container="body">{{ u.identifier | cutString }}</td>
            <td ngbTooltip="{{ u.mail }}" [openDelay]="300" container="body">{{ u.mail | cutString }}</td>
            <td ngbTooltip="{{ u.directivas }}" [openDelay]="300" container="body">{{ u.directivas | cutString }}</td>
            <td style="text-align:center">{{ u.numDirectivas }}</td>
            <td>{{ u.fuenteAsignacion }}</td>
            <td ngbTooltip="{{ u.grupos }}" [openDelay]="300" container="body">{{ u.grupos | cutString }}</td>
            <td style="text-align:center">
              <button *ngIf="u.etiquetas" class="btn btn-sm btn-outline-primary" (click)="openEtiquetasModal(u)">{{ 'directives.see' | translate }}</button>
              <span *ngIf="!u.etiquetas" class="text-muted">-</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="dpUsers?.length === 0 && !dpIsLoading" class="d-flex justify-content-center">
        <span>{{ 'noDataAvailable' | translate }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-center p-2 paginator-container" *ngIf="dpTotal > 0">
      <div class="items-per-page-container">
        <label class="mr-2 mb-0">{{ 'record.filter.itemsPerPage' | translate }}</label>
        <select
          class="form-control"
          style="width: auto; display: inline-block"
          [(ngModel)]="dpPageSize"
          (change)="applyDirectivasFilters()"
        >
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>
      </div>
      <ngb-pagination
        [collectionSize]="dpTotal"
        [(page)]="dpPage"
        [pageSize]="dpPageSize"
        [rotate]="true"
        [maxSize]="5"
        [ellipses]="false"
        [boundaryLinks]="true"
        (pageChange)="fetchDirectivas()"
      ></ngb-pagination>
    </div>
  </ng-container>
  <!-- FIN TAB 2 -->

</div>

<!-- Modal Etiquetas -->
